module.exports = __webpack_public_path__ + "img/123.18fe7ad9.png";